var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"score-content"},[_c('div',[_c('span',{staticClass:"big-score"},[_vm._v("4")]),_c('span',{staticClass:"small-score"},[_vm._v(" / 5")])]),_c('div',{staticClass:"score-title"},[_vm._v("评分")])])
}]

export { render, staticRenderFns }